// React
import React, { useEffect, useState } from 'react';
// Material-UI
import { Box, Grid, Paper } from '@material-ui/core';
// Otras libs

// Componentes
import { SelectorFecha } from './SelectorFecha';
// Funciones

// Hooks
import { useLocalization } from 'contexto/localization/useLocalization';

/**
 * Especifica la función a ser ejecutada al cambiar de fecha
 * @callback OnChange
 * @param {Date} fDesde - Nueva fecha desde
 * @param {Date} fHasta - Nueva fecha hasta
 * @returns {void}
 */

/**
 *
 * @typedef {Object} Props
 * @property {string} name Nombre de elemento
 * @property {string} label Etiqueta
 * @property {Date[]} initValues Fechas desde y hasta
 * @property {boolean} clearable Si componente permite eliminar fecha
 * @property {OnChange} onChange Evento al cambiar de fecha
 */

/**
 * Lista
 * @param {Props} props
 * @param {ChildrenFn} props.children
 * @returns
 */
export const SelectorRangoFechas = ({ 
    name = '',
    label = '',
    initValues = [], 
    clearable = false,
    onChange = (fDesde, fHasta) => {},
 }) => {
    // Idioma
    const { strings } = useLocalization();
    // Estados
    const [fechas, setFechas] = useState({
        desde: new Date(),
        hasta: new Date(),
    });

    useEffect(() => {
        if (initValues?.length === 2) {
            setFechas({ desde: initValues[0], hasta: initValues[1] });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        onChange(fechas.desde, fechas.hasta);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fechas]);


    // Vista
    return (
        <Paper variant='outlined'>
            <Box style={{ fontSize: "0.85em", margin: "-10px 0 12px 10px", padding: "0 4px 0 4px", backgroundColor: "white", display: "table", borderRadius: "5px" }}>
                {label}
            </Box>
            <Grid container>
                <Grid item xs={12} sm={6} md={6}>
                    <SelectorFecha
                        name={`${name}_fechaDesde`}
                        label={strings.modules.desde}
                        value={fechas.desde}
                        clearable={clearable}
                        onChange={(f) => {
                            setFechas((prev) => ({ 
                                desde: f,
                                hasta: f ? (prev.hasta >= f ? prev.hasta : f) : prev.hasta,
                            }));
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <SelectorFecha
                        name={`${name}_fechaHasta`}
                        label={strings.modules.hasta}
                        value={fechas.hasta}
                        clearable={clearable}
                        onChange={(f) => {
                            setFechas((prev) => ({ 
                                desde: f ? (prev.desde <= f ? prev.desde : f) : prev.desde,
                                hasta: f,
                            }));
                        }}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};
